export enum ClientPageType {
  CATEGORY = 'category',
  PDP = 'pdp',
  HOME = 'home',
  CART = 'cart',
  LANDING = 'landing',
  LISTICLE = 'listicle',
  SEARCH_RESULT = 'searchResult',
  LONG_TAIL = 'longTail',
  CONTENT = 'content',
  CHECKOUT = 'checkout',
  WISHLIST = 'wishlist',
  FINDER = 'finder',
  THEME = 'theme',
}
